// @ts-strict-ignore
import { MultipleItemResponse } from '.'
// import { NewsPage } from './models/NewsPage' TODO
import { fetchContent } from './fetchContent'
import { NewsItem } from './models/NewsItem'

const getCacheKey = (parts: any[]) => parts.filter((t) => t).join('|')
let cache = {}

const inCache = (cache, key) => typeof cache[key] !== 'undefined'

type NewsItemsArgs = {
  language: string
  limit?: number
  page?: number
}

export const getNewsArticles = async (
  args: NewsItemsArgs,
): Promise<MultipleItemResponse<NewsItem>> => {
  const { language, limit = 6, page = 1 } = args
  const key = getCacheKey(['NewsItems', language, limit, page])
  const actualPage = page > 0 ? page - 1 : 0

  if (inCache(cache, key)) {
    if (process.env.NODE_ENV === 'development') {
      console.info(`${key} returned from from cache`)
    }
    return cache[key]
  } else {
    let params = {
      limit: limit,
      skip: actualPage * limit,
      includeTotalCount: 'true',
      elements: [
        'url_slug',
        'title',
        'small_variant',
        'publication_date',
        'small_image_variant',
        'wide_image_variant',
      ],
      'system.type[in]': ['news_item'],
      order: ['elements.publication_date[desc]'],
      language,
    }

    const response: MultipleItemResponse<NewsItem> = await fetchContent({
      path: '',
      params,
    })

    cache[key] = response
    return cache[key]
  }
}
